module.exports = __webpack_public_path__ + "static/img/LB.348658d2.png";